import { SVGProps, Ref, forwardRef } from 'react';

export const VideocameraHyperstarFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M7.526 1c2.713 0 4.231.611 4.949 2.238.177.402.305.865.39 1.397l1.91-1.135H16v9h-1.225l-1.91-1.135a5.7 5.7 0 0 1-.39 1.397C11.757 14.389 10.239 15 7.526 15H5.474C1.369 15 0 13.6 0 9.4V6.6q0-.692.052-1.285c.49.442.946.956 1.283 1.461L2.5 8.523l1.165-1.747a8.1 8.1 0 0 1 2.111-2.111L7.523 3.5 5.776 2.335a8 8 0 0 1-1.466-1.29Q4.85 1 5.474 1z"
                    fill="currentColor"
                />
                <path
                    d="M2.5 1A9.5 9.5 0 0 0 5 3.5 9.5 9.5 0 0 0 2.5 6 9.5 9.5 0 0 0 0 3.5 9.5 9.5 0 0 0 2.5 1"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
VideocameraHyperstarFilledSize16Glyph.displayName = 'VideocameraHyperstarFilledSize16Glyph';
